<script setup>
import { computed } from 'vue';
import { DotsIcon } from 'vue-tabler-icons';
import { Icon } from '@iconify/vue';
import { useTranslation } from '@/utils/locales/messages';
import { useLanguageStore } from '@/shared/stores/languageStore';

const props = defineProps({ item: Object });

const languageStore = useLanguageStore();
const { createSyncT } = useTranslation();
const t = createSyncT(languageStore.currentLanguage);

// 언어 변경 시 자동으로 업데이트되도록 computed로 감싸기
const menuHeader = computed(() => {
  return t('menu.' + props.item.header) || props.item.header;
});
</script>

<template>
    <v-list-subheader  class=" text-uppercase text-13 font-weight-semibold textPrimary d-flex align-items-center">
        <span class="mini-icon"><DotsIcon size="16" stroke-width="1.5" class="iconClass" /></span>
       <span class="mini-text">{{ menuHeader }}</span> 
    </v-list-subheader>
</template>
